import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './qr-style-preview-tile.module.scss';
import type {QRStylePreviewTileProps} from './qr-style-preview-tile.types';

export function QRStylePreviewTile({previewUrl, label, isSelected, onSelect}: QRStylePreviewTileProps): ReactElement {
  return (
    <ClickableDiv className={`${styles.qrStylePreviewTile} ${isSelected ? styles.qrStylePreviewTileSelected : ''}`} aria-label={label} aria-pressed={isSelected} onClick={onSelect}>
      <div className={styles.qrStylePreviewImage} role="img" aria-label={label} style={{backgroundImage: `url(${previewUrl})`}} />
      <Text val={label} size={TextSize.SM} className={styles.qrStylePreviewLabel} />
    </ClickableDiv>
  );
}
